<template>
  <v-main>
    <v-container class="mt-16 d-flex">
      <v-row>
        <v-dialog
          v-model="inviteDialog"
          max-width="300"
        >
          <v-card light>
            <v-card-title class="text-h5">Set Password</v-card-title>
            <v-card-text>{{ dialogText }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="inviteDialog = false"
                color="primary"
              >Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-col cols="12">
          <v-form ref="form">
            <v-card
              class="mx-auto"
              flat
              outlined
              rounded="lg"
              height="500"
              max-width="600"
            >
              <v-row class="text-center">
                <v-col cols="12">
                  <div class="text-h4 my-16">Set your password</div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="password1"
                    :rules="[min8]"
                    validate-on-blur
                    label="New Password"
                    outlined
                    class="ml-16 mr-16"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    @blur="() => $refs.form.resetValidation()"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon class="mr-2">mdi-lock</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="password2"
                    :rules="[min8, matchingPasswords]"
                    validate-on-blur
                    label="Repeat Password"
                    outlined
                    class="ml-16 mr-16"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    @blur="() => $refs.form.resetValidation()"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon class="mr-2">mdi-lock</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <div class="ml-16 mr-16">
                    <v-btn
                      class="text-capitalize"
                      large
                      outlined
                      block
                      color="primary"
                      @click="savePassword"
                    >Save</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'SetPassword',
  data: () => ({
    password1: '',
    password2: '',
    show1: false,
    show2: false,
  }),
  computed: {
    inviteDialog: {
      get() {
        return this.$store.state.setPasswordErrorDialog;
      },
      set(value) {
        this.$store.commit('updateSetPasswordErrorDialog', value);
      },
    },
    dialogText() {
      return this.$store.state.setPasswordErrorDialogResponse;
    },
  },
  methods: {
    savePassword() {
      if (this.$refs.form.validate()) {
        this.$store.commit('updateSetPassword', this.password2);
        this.$store.dispatch('savePassword');
      }
    },
    min8(value) {
      if (value.length >= 8) {
        return true;
      }

      return 'Password must have a minimum of 8 characters';
    },
    matchingPasswords() {
      if (this.password1 === this.password2) {
        return true;
      }

      return 'Passwords don\'t match';
    },
  },
};
</script>

<style lang="scss">

</style>
